<template>
  <div class="xai-free-trial-unavailable-notification">
    <UtdNotification id="xaiFreeTrialUnavailableNotification"
                     notification-mode="info"
                     :has-close-notification="true"
                     @closed="emit('closed')">
      <template #title>
        Free trial unavailable
      </template>
      <template #default>
        <p class="xai-free-trial-unavailable-notification__body">
          If you have another account sign in
        </p>
      </template>
      <template #listContent>
        <div class="xai-free-trial-unavailable-notification__actions">
          <UtdButton button-size="small"
                     button-style="clean"
                     @click="handleSignIn">
            Sign in
          </UtdButton>
        </div>
      </template>
    </UtdNotification>
  </div>
</template>

<script setup>
import UtdNotification from '_acaSrc/components/shared/utd/UtdNotification.vue';
import UtdButton from '_acaSrc/components/shared/stdlib/UtdButton.vue';
import { getWindow } from '_acaSrc/utility/DOM';

const emit = defineEmits([ 'closed' ]);

const handleSignIn = () => {
    getWindow().location.href = '/login';
};
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.xai-free-trial-unavailable-notification {
  .ds1-ph-1();
  .ds1-mb-2();

  :deep(.utd-notification) {
    .ds1-mt-0();
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid @WKCE-BLUE;
    border-left: 6px solid @WKCE-BLUE;

    .utd-notification-info {
      color: @WKCE-BLUE;
    }

    .utd-notification-icon {
      color: @WKCE-BLUE !important;
    }

    .utd-notification-title {
      .ds1-pr-4();
    }
  }
}

.xai-free-trial-unavailable-notification__body {
  .ds1-ma-0();
  .ds1-mb-2();
  .ds1-utd-size-2();
  .ds1-utd-weight-normal();
  color: @WKCE-GRAY-SHADE2;
}

.xai-free-trial-unavailable-notification__actions {
  .ds1-mt-2();
  display: flex;
  gap: 8px;

  :deep(.utd-button) {
    background-color: @WKCE-GRAY-TINT5;
    color: @WKCE-BLACK;
  }
}
</style>

